import React from 'react';
import {View, StyleSheet, Platform} from 'react-native';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import AVText from 'src/components/elements/AVText';
import TagLightIcon from 'src/components/img/svg/TagLightIcon';
import Styles from 'src/components/Styles';
import TransactionStore from 'src/stores/TransactionStore';
import AccountStore from 'src/stores/AccountStore';
import Localized from 'src/constants/AppStrings';
import {scanAndPayTemplate} from 'src/components/screens/scanAndPay/templates/scanandPayThemeHelper';

export interface AfterTaxPromoProps {
  discount: number;
  onApply: () => void;
  formatCurrency: (amount: number, currency: string) => string;
}

const AfterTaxPromo: React.FC<AfterTaxPromoProps> = ({
  discount,
  onApply,
  formatCurrency,
}) => {
  const applied = TransactionStore.isAfterTaxPromoApplied();
  const displayAmount = formatCurrency(discount > 0 ? -discount : 0, AccountStore.getCurrency())

  return (
    <AVTouchableOpacity onPress={onApply} style={styles.wrapper}>
      <View style={!applied && styles.innerWrapper}>
        <View style={styles.row}>
          <View
            style={styles.rowStyle}
            accessible
            testID={
              applied
                ? 'qa_Checkout.AfterTaxLabel_txt'
                : 'qa_Checkout.ApplyAfterTaxPromo_btn'
            }
          >
            {applied && (
              <TagLightIcon
                fill={scanAndPayTemplate.discountTagColor}
                width={Styles.Spacing.m3}
                height={Styles.Spacing.m3 + Styles.Spacing.m1}
              />
            )}
            <AVText
              accessibilityLabel={
                applied
                  ? Localized.Labels.after_tax_promo_applied
                  : Localized.Labels.after_tax_lbl
              }
              aria-label={
                applied
                  ? Localized.Labels.after_tax_promo_applied
                  : Localized.Labels.after_tax_lbl
              }
              style={[
                styles.label,
                applied &&
                  Platform.OS === 'ios' && {marginTop: Styles.Spacing.m1 - 2},
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            >
              {applied
                ? Localized.Labels.after_tax_promo_applied 
                : Localized.Labels.after_tax_lbl + `(${displayAmount})`}
            </AVText>
          </View>

          {applied && (
            <AVText
              style={[
                styles.amount,
                {color: scanAndPayTemplate.discountTagColor},
              ]}
              accessibilityLabel={displayAmount}
              aria-label={displayAmount}
              accessible
              testID="qa_Checkout.AfterTaxValue_txt"
              nativeID="qa_Checkout.AfterTaxValue_txt"
            >
              {displayAmount}
            </AVText>
          )}
        </View>
      </View>
    </AVTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    marginVertical: Styles.Spacing.m2,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  label: {
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    color: scanAndPayTemplate.discountTagColor,
    textAlign: 'left',
    textDecorationLine: 'none',
  },
  amount: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    textAlign: 'right',
  },
  innerWrapper: {
    alignSelf: 'flex-start',
    borderBottomColor: scanAndPayTemplate.discountTagColor,
    borderBottomWidth: 1,
  },
  rowStyle: {flexDirection: 'row', gap: Styles.Spacing.m1},
});

export default AfterTaxPromo;
